module.exports = __webpack_public_path__ + "header-profile-skin-2.8307c45ca34d4af71912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/patterns/header-profile-skin-2.png
// module id = 1041
// module chunks = 2